import { render, staticRenderFns } from "./PezziRegistrati.vue?vue&type=template&id=75be8762&"
import script from "./PezziRegistrati.vue?vue&type=script&lang=js&"
export * from "./PezziRegistrati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports